// import treeTool from 'tree-tool';
import { WUJIE_EVENT_NAME } from '@/utils/subWujie/event';
import store from '@/store';
import { router } from "@/router";

// eslint-disable-next-line import/prefer-default-export
export function useSubWujie() {
  // const treeInstance = treeTool.createInstance({ pid: 'path' });
  function addListener() {
    const { bus } = window.$wujie;
    // eslint-disable-next-line no-undef
    bus.$on(WUJIE_EVENT_NAME.INJECT_LOGIN_DATA, (res)=>{ // 后续要优化 1s内只执行1次
      store.commit('iframe/SET_IS_HIDDEN_MENU', true);
      store
        .dispatch('user/loginFromMainApp', res)
        .then(() => {
        })

    })
    bus.$on(WUJIE_EVENT_NAME.JUMP_TO_SUB_ROUTE, (val) => {
      if(val.fullPath === router.currentRoute.fullPath) {
        return
      }
      router.replace(val.fullPath)
    });

  }
  addListener()
}

